query CurrentUser {
  currentUser {
    id
    email
    phone
    firstName
    middleName
    lastName
    displayName
    country
    language
    timeZone
    agreeToMarketingNewsletters
    currentOrganizationId
    currentOrganization {
      id
      title
      currency
      assistantEnabled
    }
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    isSuperAdmin
    isPartner
    currentOrganizationRoles
    abilityRules
  }
}
